module.exports = __webpack_public_path__ + "static/media/InsytLogo.c0d944b7.svg";